// One disclosure behavior for the React games and the plain HTML player.
export function connectControlMenu(container) {
  const trigger = container.querySelector('.recess-menu-toggle');
  const panel = container.querySelector('.recess-controls-panel');
  let open = false;
  function position() {
    if (!open) return;
    const height = window.visualViewport?.height || window.innerHeight;
    const top = Math.max(8, Math.min(trigger.getBoundingClientRect().bottom + 8, height - 100));
    container.style.setProperty('--recess-menu-top', `${top}px`);
    container.style.setProperty('--recess-menu-height', `${Math.max(80, height - top - 16)}px`);
  }
  function render() {
    position();
    trigger.hidden = false;
    panel.hidden = !open;
    trigger.setAttribute('aria-expanded', String(open));
    container.classList.toggle('is-open', open);
  }
  function close(restoreFocus = false) {
    if (!open) return;
    open = false;
    render();
    if (restoreFocus) trigger.focus({ preventScroll: true });
  }
  function toggle() { open = !open; render(); }
  function action(event) { if(event.target.closest('[data-recess-dismiss]')) close(true); }
  function accountOpen() { close(false); }
  function outside(event) {
    // Keep the Account trigger available for the dialog's focus restoration.
    if (document.querySelector('dialog[open]')) return;
    if (!container.contains(event.target)) close(panel.contains(document.activeElement));
  }
  function keydown(event) {
    if (event.key === 'Escape' && open && !event.defaultPrevented) {
      // React's delegated handler runs after native bubbling here. Let the
      // inner Games menu consume its first Escape before closing this panel.
      if (event.target.closest('.games-switcher')?.querySelector('[aria-haspopup="menu"][aria-expanded="true"]')) return;
      event.preventDefault();
      event.stopPropagation();
      const games = event.target.closest('details.games[open]');
      if (games) { games.open = false; games.querySelector('summary').focus(); return; }
      close(true);
    }
  }
  trigger.addEventListener('click', toggle);
  container.addEventListener('click', action);
  container.addEventListener('keydown', keydown);
  document.addEventListener('pointerdown', outside);
  document.addEventListener('recess-account-open', accountOpen);
  window.addEventListener('resize', position);
  window.addEventListener('scroll', position, true);
  window.visualViewport?.addEventListener('resize', position);
  window.visualViewport?.addEventListener('scroll', position);
  render();
  return () => {
    trigger.removeEventListener('click', toggle);
    container.removeEventListener('click', action);
    container.removeEventListener('keydown', keydown);
    document.removeEventListener('pointerdown', outside);
    document.removeEventListener('recess-account-open', accountOpen);
    window.removeEventListener('resize', position);
    window.removeEventListener('scroll', position, true);
    window.visualViewport?.removeEventListener('resize', position);
    window.visualViewport?.removeEventListener('scroll', position);
  };
}
